import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TRAVEL_FILTERS } from '../../utils/constants';

const displayOnlyForStornoKey = 'storno';

const propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  vacation: PropTypes.object
};
const defaultProps = {
  className: ''
};

class ListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false
    };
  }

  handleDesc = () => {
    const { description } = this.props;

    if (description && description.length) {
      this.setState({ opened: !this.state.opened });
    }
  };

  getPrice = () => {
    const { valueSingleInland, valueSingleAbroad, valueFamilyInland, valueFamilyAbroad, vacation } = this.props;

    let price;

    if (vacation.type === TRAVEL_FILTERS.FAMILY) {
      price = vacation.destination === TRAVEL_FILTERS.FOREIGN ? valueFamilyAbroad : valueFamilyInland;
    } else if (vacation.type === TRAVEL_FILTERS.SINGLE) {
      price = vacation.destination === TRAVEL_FILTERS.FOREIGN ? valueSingleAbroad : valueSingleInland;
    }

    return price;
  };

  render() {
    const { className, title, description, vacation, internalId } = this.props;
    const { opened } = this.state;

    const descriptionClass = description && description.length ? 'has-description' : '';

    if (internalId === displayOnlyForStornoKey && !vacation.cancellation) return null;

    return (
      <li className={`list-item-wrapper ${className} ${descriptionClass}`} onClick={this.handleDesc}>
        <span className={`list-item-wrapper__title ${opened ? 'open' : ''} ${descriptionClass}`}>{title}</span>
        <span className="list-item-wrapper__price">{this.getPrice()}</span>
        {opened && <div className="list-item-wrapper__desc">{description}</div>}
      </li>
    );
  }
}

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;

export default ListItem;
